import { createContext, useContext } from 'react';

export const DocumentContext = createContext(undefined);

export const useDocumentContext = () => {
  const cxt = useContext(DocumentContext);

  if (!cxt) throw new Error('useDocumentContext must be used with provider');

  return cxt;
};
